import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=fc4fc2b2&scoped=true"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"
import style1 from "./forgetPassword.vue?vue&type=style&index=1&id=fc4fc2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4fc2b2",
  null
  
)

export default component.exports